import React from 'react';
import Logo from 'global/components/Logo/index';
import Nav from 'website/components/Nav/index';
import {NavLink} from 'react-router-dom';
import CartButton from 'website/components/CartButton/index';
import LanguageToggle from 'global/components/LanguageToggle/index';
import LayoutBuilder from 'LayoutBuilder';
import {SERVER_RENDER_DEFAULT_SITE_INFO}  from 'App';
import {DangerSet} from 'global/utils/helper-functions';


const {Container, Row, Column} = LayoutBuilder;

export default class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showNav: true
    };
  }
  
  componentDidMount(){     
    this.LoginEventKey = window.GlobalUtil.subscribeEvent("LoginEvent", curSession=>{
      this.setState({
        date: new Date(),
        isLoggedIn: window.GlobalUtil.getGlobalVariable("isLoggedIn", false)
      })
    });
 
    document.addEventListener("scroll", this.scrollHelper);
    this.scrollHelper();
    var HeaderStyles = {"height": this.HeaderRef.offsetHeight+"px", "minHeight": "92px"};
    this.setState({
      HeaderStyles: HeaderStyles,
      isLoggedIn: window.GlobalUtil.getGlobalVariable("isLoggedIn", false)
    })
  }

  componentWillUnmount(){
    this.LoginEventKey.unsubscribe();
    document.removeEventListener("scroll", this.scrollHelper);
  }

  scrollHelper = (e) => {
    var {offtop} = this.state;
    //console.log("document.documentElement.scrollTop ","\n\n",document.documentElement.scrollTop,"\n\n");
    const scrollTop = document.documentElement.scrollTop;
    if(scrollTop > 0){
      if(!offtop) this.setState({offtop: true});
    } else {
      if(offtop) this.setState({offtop: false});
    }
  }


  resetNav = () => {
    this.setState({resetNav: false}, ()=>this.setState({resetNav: true}));
  }

  render(){

    var {showNav, offtop, HeaderStyles={"minHeight": "92px"}, isLoggedIn} = this.state;
    var Session = (typeof window === 'undefined') ?  SERVER_RENDER_DEFAULT_SITE_INFO : window.Session;
    var CurDate = new Date();           
    
    return (
      <div ref={e=>this.HeaderRef=e} id="Header" className={offtop ? "offtop" : ""} style={HeaderStyles}>
        <div className={"headerFloater "+(HeaderStyles.height ? "floatingFixed" : "")}>
          <div className="preHeaderWrapper">
            <Container className="">
              <Row className="preHeaderRow">
                <Column className="" col="" sm="" sm="" md="" lg="" xl="">
                  {
                    isLoggedIn
                    ? <div className="loginMenu">
                        { 
                          (Session.user.role === "ADMIN") && 
                          <NavLink className={"nav-link"} onClick={this.resetNav} to={"/admin"}>Admin</NavLink>
                        }
                        <NavLink className={"nav-link"} onClick={this.resetNav} to={"/user"}>User</NavLink>
                        <div className={"nav-link"} onClick={(typeof window === 'undefined') ? ()=>{} : window.GlobalUtil.logout}>Logout</div>
                      </div>
                    : <div className="loginMenu">
                        {
                          (Session.Language === "ESPAÑOL") 
                          ? <NavLink className={"nav-link"} onClick={this.resetNav} to={"/acceso"}>Iniciar Sesión</NavLink>
                          : <NavLink className={"nav-link"} onClick={this.resetNav} to={"/login"}>Login</NavLink>
                        }
                        
                        {/*<NavLink className={"nav-link"} onClick={this.resetNav} to={"/login"}>Sign Up</NavLink>*/}
                      </div>
                  }
                      
                </Column>
                <Column className="" col="" sm="" md="" lg="" xl="">
                  <LanguageToggle/>
                </Column>
              </Row>
            </Container>
          </div>
          <Container className="headerContainer">
            <Row className="">
              <Column className="image-column" col="" sm="" sm="" md="" lg="" xl="">
                <Logo type="dark"/>
              </Column>
              <Column className="menu-col d-none d-sm-none d-md-none d-lg-flex" col="" sm="" md="" lg="" xl="">
                <div className="menu-nav d-none d-sm-none d-md-none d-lg-flex">
                  {showNav && <Nav onClickLink={this.resetNav} MenuToShow={Session.Language === "ESPAÑOL" ? "EspHeader" :"Header"} inline="true" />}
                  <CartButton />
                </div>
              </Column>
              <div className="mobile-button d-flex d-sm-flex d-md-flex d-lg-none">
                <CartButton />
                <div className="mobile-button-box">
                  <i className="fas fa-bars" onClick={this.props.onShowSideMenu} />
                </div>
              </div>
            </Row>
          </Container>
        </div>
      </div>
    );
  }
}




// const LOGO = (
// <svg width="100%" height="100%" viewBox="0 0 2085 1103" style={{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}}>
//     <g transform="matrix(1,0,0,1,-6632.36,0)">
//         <g id="Artboard4" transform="matrix(1.03935,0,0,0.868096,-677.14,290.866)">
//             <rect x="7032.77" y="-335.062" width="2005.98" height="1269.96" style={{"fill":"none"}}/>
//             <g transform="matrix(0.96214,0,0,1.15195,397.915,-1756.04)">
//                 <path d="M8410.02,2273.91L7850.45,2273.91C7824.69,2273.72 7798.94,2273.53 7773.18,2273.33C7759.08,2273.23 7745.03,2270.34 7732.03,2264.89C7720.31,2259.97 7709.49,2252.99 7700.18,2244.34C7691.65,2236.41 7684.41,2227.11 7678.83,2216.89C7673.96,2207.96 7670.35,2198.36 7668.15,2188.43C7665.91,2178.37 7665.12,2167.99 7665.81,2157.71C7666.56,2146.47 7669.07,2135.36 7673.25,2124.9C7677.42,2114.43 7683.24,2104.62 7690.44,2095.95C7718.01,2062.7 7773.15,1996.21 7773.15,1996.21L7984.67,1996.21C7984.67,1996.21 7910.37,2085.84 7871.99,2132.13C7867.91,2137.05 7867.05,2143.87 7869.76,2149.65C7872.48,2155.43 7878.29,2159.12 7884.67,2159.12C7954.42,2159.12 8114.53,2159.12 8238.14,2159.12C8337.67,2159.12 8432.97,2118.84 8502.32,2047.44C8571.67,1976.05 8609.18,1879.63 8606.3,1780.14L8606.3,1780.13C8600.86,1592.58 8447.15,1443.42 8259.51,1443.63C7884.21,1444.06 7013.5,1445.04 7013.5,1445.04C7013.5,1445.04 7012.27,1444.88 7009.97,1444.58C6982.07,1441.01 6960.84,1417.82 6959.73,1389.72C6958.62,1361.62 6977.96,1336.83 7005.49,1331.07C7005.49,1331.07 7005.5,1331.07 7005.5,1331.07C7005.5,1331.07 8245.31,1276.67 8397.36,1270.01C8421.05,1268.97 8444.78,1269.82 8468.34,1272.54C8704.24,1299.76 8915.88,1497.85 8915.88,1793.35C8915.88,2111.97 8667.25,2273.91 8410.02,2273.91ZM7811.98,1644.16L7762.37,1644.9C7712.74,1645.04 7672.49,1685.38 7672.49,1735.05C7672.49,1784.8 7712.87,1825.19 7762.62,1825.21C7762.62,1825.21 8099.65,1824.83 8253.09,1824.66C8272.71,1824.64 8291.51,1832.52 8305.26,1846.51C8319.02,1860.51 8326.56,1879.45 8326.19,1899.07C8326.19,1899.27 8326.19,1899.48 8326.18,1899.68C8325.43,1940.01 8292.53,1972.3 8252.2,1972.3C8100.05,1972.3 7761.77,1972.3 7761.77,1972.3C7631.24,1971.83 7525.4,1865.7 7525.4,1735.05C7525.4,1604.27 7631.45,1498.06 7762.17,1497.81L7762.44,1497.81L7762.82,1497.81L8167.68,1497.81C8226.78,1497.81 8274.93,1545.26 8275.79,1604.36C8275.79,1604.36 8275.79,1604.37 8275.79,1604.37C8276.17,1630.17 8267.33,1655.26 8250.86,1675.13L8148.17,1798.99L7936.72,1798.99C7971.17,1757.46 8005.61,1715.93 8040.06,1674.4C8044.62,1668.89 8045.6,1661.24 8042.56,1654.77C8039.51,1648.29 8033,1644.16 8025.85,1644.16L7811.98,1644.16Z" 
//                 style={{"fill":"rgb(13,13,13)","fillRule":"nonzero"}}/>
//             </g>
//         </g>
//     </g>
// </svg>
// );